const ARNOLD_LS_PREFIXES = [
  'channelForSurvey',
  '@Arnold',
  'sysAdminInReports',
  'topicEditor',
  'hideRespondents',
  'AiSurvey',
  'versionUpdateNeeded',
  'i18nextLng',
];

export function clearLocalStorageFromNonArnoldItems() {
  const smartLookLSItems = Object.entries(localStorage).filter(
    (item) => !ARNOLD_LS_PREFIXES.some((prefix) => item[0].startsWith(prefix)),
  );
  smartLookLSItems.forEach((item) => localStorage.removeItem(item[0]));
}
